import * as React from "react";
import { styled } from "@mui/material";
import { ReactComponent as KahunLogo } from "../../../../assets/clinic/kahunLogo.svg";
import { useClinicState } from "../../../../clinic/clinicStateContext";
import { useMemo, useEffect } from "react";
import { conversationLink } from "../../elements/shareLink";
import QrCode from "qrcode.react";

//region [[ Styles ]]

const ClinicInvitePrintView = styled("div")({
  display: "flex",
  position: "absolute",
  height: "100%",
  width: "100%",
  flexFlow: "column",
  alignItems: "center",
});

const Title = styled("h1")({
  color: "#5a52c3",
});

const QrCodeText = styled("div")({
  color: "#5a52c3",
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  margin: "15px",
});

const LinkText = styled("div")({
  fontSize: "15px",
  fontWeight: 700,
  alignText: "center",
});

const PoweredBy = styled("div")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  width: "600px",
  margin: "25px",
  alignItems: "center",
  "& svg": {
    margin: "10px",
    width: "100px",
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicInvitePrint = () => {
  const [
    {
      clinicData: { name },
    },
  ] = useClinicState();

  const link = useMemo(() => conversationLink(name), [name]);

  useEffect(() => window.print(), []);

  return (
    <ClinicInvitePrintView>
      <Title>Scan this code to start your clinical intake</Title>
      <QrCode value={link} size={500} />
      <QrCodeText>
        Or go to:<LinkText>{link}</LinkText>
      </QrCodeText>
      <PoweredBy>
        Powered by
        <KahunLogo />
      </PoweredBy>
    </ClinicInvitePrintView>
  );
};
